import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { SEASON_CONFIG_URL } from "../../../../api/api_routing_urls";
// import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";

import AddSeasonForm from "./addSeasonForm.component";
import SeasonList from "./seasonList.component";

const SeasonConfig = () => {
  // const { auth } = useAuth();
  const [seasonList, setSeasonList] = useState([]);
  // const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editSeasonDetails, setEditSeasonDetails] = useState({});
  const isEdit = Object.keys(editSeasonDetails).length > 0 ? true : false;

  const getSeasonList = async () => {
    try {
      const response = await axios.get(SEASON_CONFIG_URL);
      // console.log("Season List", { response });
      response.status === 200 && setSeasonList(response.data.seasonList);
      response.status === 202 &&
        showToast("No season entries found in the system.", "error");
    } catch (error) {
      console.error("getSeasonList", error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getSeasonList();
      setEditSeasonDetails({});
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    // <Dashboard sidebarType={auth.rolename}>
    <Dashboard>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Season"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${isEdit ? "Update Season Details" : "Add Season Details"}`}
        isAdd={true}
        clearData={setEditSeasonDetails}
      >
        <AddSeasonForm
          getSeasonList={getSeasonList}
          editSeasonDetails={editSeasonDetails}
          setEditSeasonDetails={setEditSeasonDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <SeasonList
          seasonList={seasonList}
          getSeasonList={getSeasonList}
          setEditSeasonDetails={setEditSeasonDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default SeasonConfig;
